import { GoogleAuthProvider, signInWithPopup, signInAnonymously, signOut, createUserWithEmailAndPassword, signInWithEmailAndPassword ,sendPasswordResetEmail , updateProfile, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { API_URL } from '../pages/config';

let anonInProgress = false; // Prevent redundant sign-ins

// Google Login
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const user = result.user;
  const token = await user.getIdToken();

  // Check if the user is new by comparing creationTime and lastSignInTime
  const isNewUser = user.metadata.creationTime === user.metadata.lastSignInTime;

  if (isNewUser) {
    // API call to send welcome email
    await fetch(`${API_URL}/api/send-welcome-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: user.email }),
    });
  }

  return { user, token };
};

// Email Sign Up
export const signUpWithEmail = async (email, password, displayName) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const token = await userCredential.user.getIdToken();
  await updateProfile(userCredential.user, { displayName });
  // API call to send welcome email
  await fetch(`${API_URL}/api/send-welcome-email`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  return { user: userCredential.user, token };
};

// Email Login
export const signInWithEmail = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  const token = await userCredential.user.getIdToken();
  return { user: userCredential.user, token };
};

// Anonymous Login
export const signInAnon = async () => {
  if (auth.currentUser || anonInProgress) return;

  anonInProgress = true;
  try {
    const result = await signInAnonymously(auth);
    return { user: result.user, token: await result.user.getIdToken() };
  } catch (error) {
    console.error("signInAnon error:", error);
  } finally {
    anonInProgress = false;
  }
};

// Logout
export const logout = async () => {
  await signOut(auth);
};

// 🔒 Forgot Password
export const sendResetPasswordEmail = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      return { success: true, message: "Reset email sent successfully." };
    } catch (error) {
      return { success: false, message: error.message };
    }
  };

// Setup reCAPTCHA verifier
export const setupRecaptcha = (isVisible = false) => {
  if (window.recaptchaVerifier) {
    window.recaptchaVerifier.clear();
    window.recaptchaVerifier = null;
  }
  window.recaptchaVerifier = new RecaptchaVerifier(auth,'recaptcha-container', 
    {
      size: isVisible ? 'normal' : 'invisible',
      callback: (response) => {
        // reCAPTCHA solved
      },
      'expired-callback': () => {
        // Response expired
      }
    });
  if (isVisible) {
    window.recaptchaVerifier.render().catch((error) => {
      console.error("Error rendering reCAPTCHA:", error);
    });
  }
};

// Send OTP to phone
export const sendOtpToPhone = async (phoneNumber, isVisible = false) => {
  try {
    setupRecaptcha(isVisible);
    const appVerifier = window.recaptchaVerifier;
    const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
    window.confirmationResult = confirmationResult;
    return { success: true, message: "OTP sent successfully." };
  } catch (error) {
    console.error("Error sending OTP:", error);
    return { success: false, message: error.message };
  }
};

// Verify OTP
export const verifyOtp = async (otp) => {
  try {
    if (!window.confirmationResult) {
      throw new Error("No confirmation result found. Please send OTP first.");
    }
    const result = await window.confirmationResult.confirm(otp);
    const user = result.user;
    const token = await user.getIdToken();
    return { success: true, user, token };
  } catch (error) {
    console.error("Error verifying OTP:", error);
    return { success: false, message: error.message };
  } finally {
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
      window.recaptchaVerifier = null;
    }
  }
};